import React, { useEffect, useState } from "react";
import {
  Col,
  InputGroup,
  Row,
  Form as BForm,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "@themesberg/react-bootstrap";
import { getAdminConfiguration } from "../../utils/apiCalls";
import { BoxContainer, NoDataContainer, UpdateButton } from "./style";
import { InlineLoader } from "../Preloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDollarSign,
  faInfoCircle,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import * as Yup from "yup";
import styled from "styled-components";
import {BONUS_CONFIGS} from "./constants"
import {bonusConfigSchema} from "./schema"




const BonusConfig = ({ updateData , title}) => {
  const [details, setDetails] = useState(null);
  const [isGetLoading, setIsGetLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [originalValues, setOriginalValues] = useState({});
  const [errors, setErrors] = useState({});
  const [updatingCategories, setUpdatingCategories] = useState({});
  const [touchedFields, setTouchedFields] = useState({}); // Track which fields have been interacted with

  useEffect(() => {
    setIsGetLoading(true);
  
    async function fetchData() {
      try {
        const res = await getAdminConfiguration();
        const adminConfigInfo = res?.data?.data?.result || [];
        setDetails(adminConfigInfo);
  
        const initialValues = {};
        BONUS_CONFIGS.forEach(({ fields, slug }) => {
          // Find the category in the API response by slug
          const categoryConfig = adminConfigInfo.find((item) => item.key === slug);
          const categoryValues = categoryConfig ? categoryConfig.value : {};
  
          // Initialize each field for the category
          fields.forEach(({ value }) => {
            const fieldKey = value.replace(`${slug}_`, ""); // e.g., "freebet_is_active" -> "is_active"
            // Use the nested value from the API response or default to empty string
            initialValues[value] =
              categoryValues[fieldKey] !== undefined
                ? categoryValues[fieldKey].toString()
                : "";
          });
        });
  
        console.log(initialValues, adminConfigInfo, "initialValuesinitialValuesinitialValues");
        setFormValues(initialValues);
        setOriginalValues(initialValues);
  
        // DON'T validate all fields initially - removed this part
        // Only clear errors to ensure clean state
        setErrors({});
        setTouchedFields({});
      } catch (error) {
        console.error("Error fetching bonus configuration:", error);
      } finally {
        setIsGetLoading(false);
      }
    }
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    
    // Only validate if the field has been touched before
    if (touchedFields[name]) {
      validateField(name, value);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    
    // Mark field as touched
    setTouchedFields((prev) => ({
      ...prev,
      [name]: true,
    }));
    
    // Validate field on blur
    validateField(name, value);
  };

  const validateField = async (fieldName, value) => {
    try {
      let processedValue = value?.trim();
      if (fieldName.includes("is_active")) {
        processedValue = processedValue;
      } else {
        processedValue = processedValue === "" ? processedValue : Number(processedValue);
      }

      await Yup.reach(bonusConfigSchema, fieldName).validate(processedValue);

      setErrors((prev) => ({
        ...prev,
        [fieldName]: null,
      }));

      return true;
    } catch (validationError) {
      setErrors((prev) => ({
        ...prev,
        [fieldName]: validationError.message,
      }));

      return false;
    }
  };

  const handleSubmit = async (categoryFields, categoryTitle, slug) => {
    setUpdatingCategories((prev) => ({
      ...prev,
      [categoryTitle]: true,
    }));

    try {
      // Mark all fields in this category as touched before validation
      const categoryTouchedFields = {};
      categoryFields.forEach(({ value }) => {
        categoryTouchedFields[value] = true;
      });
      setTouchedFields((prev) => ({
        ...prev,
        ...categoryTouchedFields,
      }));

      // Validate all fields in the category
      const validations = await Promise.all(
        categoryFields.map(async ({ value }) => ({
          value,
          isValid: await validateField(value, formValues[value]),
        }))
      );

      // Check if all fields are valid
      const isValid = validations.every((v) => v.isValid);
      if (!isValid) {
        setUpdatingCategories((prev) => ({
          ...prev,
          [categoryTitle]: false,
        }));
        return;
      }
    let updatePayload = categoryFields.reduce((acc, { value }) => {
        const prefix = slug + "_";
        const keyName = value;
        // If changed, use formValues; otherwise, use originalValues
        const fieldValue = hasFieldChanged(value)
          ? keyName.includes("is_active")
            ? formValues[value] === "true"
            : formValues[value]
          : originalValues[value];
      
        acc[value.replace(prefix, "")] = fieldValue;
        return acc;
      }, {});

      

      // Structure payload as { key: slug, value: {...} }
      if (Object.keys(updatePayload).length > 0) {
        updatePayload = {
          key: slug,
          value: updatePayload,
        };

        // Send batch update
        const response = await updateData(updatePayload);
        console.log({ updatePayload, categoryTitle, response }, "payloaddddddddddddddddddddddd");

        // Update original values for changed fields
        const updatedValues = {};
        categoryFields.forEach(({ value }) => {
          if (hasFieldChanged(value)) {
            updatedValues[value] = formValues[value];
          }
        });
        setOriginalValues((prev) => ({
          ...prev,
          ...updatedValues,
        }));
      } else {
        setUpdatingCategories((prev) => ({
          ...prev,
          [categoryTitle]: false,
        }));
        return;
      }
    } catch (error) {
      console.error(`Error updating ${categoryTitle}:`, error);
    } finally {
      setUpdatingCategories((prev) => ({
        ...prev,
        [categoryTitle]: false,
      }));
    }
  };

  const hasFieldChanged = (fieldName) => {
    return formValues[fieldName]?.toString() !== originalValues[fieldName]?.toString();
  };

  const hasCategoryChanged = (fields) => {
    return fields.some(({ value }) => hasFieldChanged(value));
  };

  const hasCategoryErrors = (fields) => {
    return fields.some(({ value }) => {
      // Check if field is empty (required fields must be filled)
      const isEmpty = formValues[value] === "" || formValues[value] === undefined;
      
      // Check if field has validation errors
      const hasValidationError = !!errors[value];
      
      // Field has error if it's empty OR has validation errors
      return isEmpty || hasValidationError;
    });
  };

  const renderFormField = (fieldConfig, index) => {
    const { key, value, type, options } = fieldConfig;

    if (type === "select") {
      return (
        <StyledFormSelect
          name={value}
          value={formValues[value] || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touchedFields[value] && !!errors[value]} // Only show invalid state if touched
        >
          <option value="">Select an option</option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </StyledFormSelect>
      );
    }

    return (
      <InputGroup className="flex-grow-1 me-2">
        {(key.includes("Amount") || key.includes("Wager") || key.includes("Threshold")) && (
          <StyledInputGroupText className="bg-white border-primary-subtle">
            <FontAwesomeIcon icon={faDollarSign} />
          </StyledInputGroupText>
        )}
        <StyledFormControl
          type={type || "text"}
          name={value}
          value={formValues[value] || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touchedFields[value] && !!errors[value]} // Only show invalid state if touched
          isusd={(key.includes("Amount") || key.includes("Wager") || key.includes("Threshold")).toString()}
        />
      </InputGroup>
    );
  };

  return (
    <BoxContainer className="FormsBg">
       <h3 className="mb-2 mt-2"> {title}</h3>
      {isGetLoading ? (
        <NoDataContainer>
          <InlineLoader />
        </NoDataContainer>
      ) : (
        <>
          {details && (
            <>
              {BONUS_CONFIGS.map((bonus, bonusIndex) => (
                <div key={bonusIndex} className="mb-3 mt-4">
                  <h4 className="text-primary fw-bold mb-3">{bonus.title}</h4>
                  <p className="text-muted mb-4">{bonus.trigger}</p>
                  <Row>
                    {bonus.fields.map((fieldConfig, fieldIndex) => {
                      const { key, value, info, type } = fieldConfig;

                      return (
                        <Col md={6} sm={12} className="mb-4" key={fieldIndex}>
                          <div className="field-container p-3 border rounded bg-white shadow-sm">
                            <BForm.Label className="form-label mb-2 d-flex align-items-center">
                              <span className="fw-bold text-primary">
                                {key || "N/A"}
                              </span>
                              {info && (
                                <OverlayTrigger
                                  placement="right"
                                  overlay={
                                    <Tooltip id={`tooltip-${bonusIndex}-${fieldIndex}`}>
                                      {info}
                                    </Tooltip>
                                  }
                                >
                                  <span className="ms-2">
                                    <FontAwesomeIcon
                                      icon={faInfoCircle}
                                      className="text-warning"
                                    />
                                  </span>
                                </OverlayTrigger>
                              )}
                            </BForm.Label>

                            <div className="d-flex align-items-center">
                              {type === "select" ? (
                                <div className="flex-grow-1 me-2">
                                  {renderFormField(fieldConfig, fieldIndex)}
                                </div>
                              ) : (
                                renderFormField(fieldConfig, fieldIndex)
                              )}
                            </div>

                            {/* Only show errors if field has been touched */}
                            {touchedFields[value] && errors[value] && (
                              <div className="text-danger mt-1 small">
                                {errors[value]}
                              </div>
                            )}
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                  <div className="d-flex justify-content-end mt-3">
                    <UpdateButton
                      hasChanges={hasCategoryChanged(bonus.fields)}
                      disabled={
                        updatingCategories[bonus.title] ||
                        hasCategoryErrors(bonus.fields) ||
                        !hasCategoryChanged(bonus.fields)
                      }
                      onClick={() => handleSubmit(bonus.fields, bonus.title, bonus.slug)}
                      type="button"
                    >
                      {updatingCategories[bonus.title] ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faSave} className="me-2" />
                          Update {bonus.title}
                        </>
                      )}
                    </UpdateButton>
                  </div>
                </div>
              ))}
            </>
          )}
        </>
      )}
    </BoxContainer>
  );
};

export default BonusConfig;

const StyledFormControl = styled(BForm.Control)`
  border-radius: ${(props) =>
    props.isusd === "true" ? "0 0.3rem 0.3rem 0" : "0.3rem"} !important;
  border-color: #d1d7e0 !important;

  &:focus {
    box-shadow: none !important;
    border-color: rgb(132, 0, 255) !important;
  }
`;

const StyledFormSelect = styled(BForm.Select)`
  border-radius: 0.3rem !important;
  border-color: #d1d7e0 !important;

  &:focus {
    box-shadow: none !important;
    border-color: rgb(132, 0, 255) !important;
  }
`;

const StyledInputGroupText = styled(InputGroup.Text)`
  border-radius: 0.3rem 0 0 0.3rem !important;
`;